import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDynamicDataService } from '../../efaact.dynamic-data-service';
import { StatusData } from './role-status.model';

export const entityName = 'RoleStatus';

@Injectable()
export class RoleStatusDataService extends EfaactDynamicDataService<StatusData> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(
            http,
            httpUrlGenerator,
            entityName,
            log,
            { ...config, root: `${config.root}/dashboard` },
            store
        );
    }

    mapItems(item: StatusData): StatusData {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: `${item.ProcessID}-${item.RoleID}-${item.RoleAction}`
        };
    }
}
